export const sampleRelatedOdds = [
    {
        "_id": "67c073dd13d53725f6af4de0",
        "bet_price_over": 2.7,
        "bet_price_under": 1.56,
        "sportsbook": "bet365"
    },
    {
        "_id": "67c073de13d53725f6af5b3e",
        "bet_price_over": 1.901,
        "sportsbook": "Pinnacle",
        "bet_price_under": 1.84
    },
    {
        "_id": "67c073e013d53725f6af76e1",
        "bet_price_over": 2.22,
        "sportsbook": "Superbet",
        "bet_price_under": 1.613
    },
    {
        "_id": "67c073dc13d53725f6af39ac",
        "bet_price_under": 1.8,
        "sportsbook": "BetVictor",
        "bet_price_over": 1.926
    },
    {
        "_id": "67c073dc13d53725f6af3edd",
        "bet_price_under": 1.69,
        "sportsbook": "Fliff",
        "bet_price_over": 2
    },
    {
        "_id": "67c073dc13d53725f6af3f9c",
        "bet_price_over": 2.05,
        "sportsbook": "Hard Rock",
        "bet_price_under": 1.667
    },
    {
        "_id": "67c073dc13d53725f6af41cb",
        "bet_price_under": 1.73,
        "sportsbook": "Caesars (Ontario)",
        "bet_price_over": 2
    },
    {
        "_id": "67c073dd13d53725f6af486f",
        "bet_price_over": 2,
        "sportsbook": "Blue Book"
    },
    {
        "_id": "67c073dd13d53725f6af49cc",
        "bet_price_under": 1.714,
        "sportsbook": "ESPN BET"
    },
    {
        "_id": "67c073dd13d53725f6af4e04",
        "bet_price_under": 1.833,
        "sportsbook": "Bodog",
        "bet_price_over": 1.909
    },
    {
        "_id": "67c073dd13d53725f6af5080",
        "bet_price_over": 2.1,
        "sportsbook": "Betano"
    },
    {
        "_id": "67c073de13d53725f6af568e",
        "bet_price_under": 1.662,
        "sportsbook": "HotStreak",
        "bet_price_over": 2.01
    },
    {
        "_id": "67c073de13d53725f6af5cda",
        "bet_price_under": 1.73,
        "sportsbook": "Caesars (Tennessee)"
    },
    {
        "_id": "67c073df13d53725f6af5f72",
        "bet_price_under": 1.714,
        "sportsbook": "Onyx Odds"
    },
    {
        "_id": "67c073df13d53725f6af63bb",
        "bet_price_over": 2,
        "sportsbook": "William Hill",
        "bet_price_under": 1.73
    },
    {
        "_id": "67c073e013d53725f6af6db0",
        "bet_price_over": 2,
        "sportsbook": "Sportzino"
    },
    {
        "_id": "67c073e013d53725f6af6db9",
        "bet_price_under": 1.714,
        "sportsbook": "DraftKings",
        "bet_price_over": 2.1
    },
    {
        "_id": "67c073e013d53725f6af7559",
        "bet_price_over": 2,
        "sportsbook": "Sporttrade (Virginia)",
        "bet_price_under": 1.709
    },
    {
        "_id": "67c073e013d53725f6af795f",
        "bet_price_over": 2.14,
        "sportsbook": "1XBet"
    },
    {
        "_id": "67c073e213d53725f6af9033",
        "bet_price_over": 2.26,
        "bet_price_under": 1.6,
        "sportsbook": "Betway (Alaska)"
    },
    {
        "_id": "67c0775d13d53725f6b1d383",
        "bet_price_under": 1.69,
        "sportsbook": "Borgata",
        "bet_price_over": 2.05
    },
    {
        "_id": "67c0775d13d53725f6b1d3c5",
        "bet_price_under": 1.775,
        "sportsbook": "BetUS",
        "bet_price_over": 2
    },
    {
        "_id": "67c0775e13d53725f6b1da16",
        "bet_price_over": 2,
        "sportsbook": "Caesars",
        "bet_price_under": 1.73
    },
    {
        "_id": "67c0775e13d53725f6b1dbc6",
        "bet_price_over": 1.99,
        "sportsbook": "Betplay",
        "bet_price_under": 1.781
    },
    {
        "_id": "67c0775e13d53725f6b1dd80",
        "bet_price_under": 1.694,
        "sportsbook": "Betway",
        "bet_price_over": 2.1
    },
    {
        "_id": "67c0775f13d53725f6b1dfd8",
        "bet_price_over": 1.909,
        "sportsbook": "Bovada",
        "bet_price_under": 1.833
    },
    {
        "_id": "67c0776013d53725f6b1e592",
        "bet_price_under": 1.69,
        "sportsbook": "bwin",
        "bet_price_over": 2.05
    },
    {
        "_id": "67c0776213d53725f6b1f393",
        "bet_price_over": 1.99,
        "sportsbook": "BetOnline"
    },
    {
        "_id": "67c0776213d53725f6b1f63b",
        "bet_price_over": 2.1,
        "sportsbook": "Fanatics",
        "bet_price_under": 1.714
    },
    {
        "_id": "67c0776413d53725f6b202f5",
        "bet_price_over": 2.1,
        "sportsbook": "Bet Right"
    },
    {
        "_id": "67c0776613d53725f6b20ca3",
        "bet_price_under": 1.714,
        "sportsbook": "Mise-o-jeu",
        "bet_price_over": 2.1
    },
    {
        "_id": "67c0776613d53725f6b20d2c",
        "bet_price_under": 1.714,
        "sportsbook": "theScore"
    },
    {
        "_id": "67c0776713d53725f6b211a0",
        "bet_price_over": 2,
        "sportsbook": "Sporttrade (Colorado)",
        "bet_price_under": 1.709
    },
    {
        "_id": "67c0776813d53725f6b21bfc",
        "bet_price_over": 1.901,
        "sportsbook": "Pinny"
    },
    {
        "_id": "67c0776813d53725f6b21e73",
        "bet_price_over": 1.855,
        "sportsbook": "TonyBet"
    },
    {
        "_id": "67c0776813d53725f6b21f20",
        "bet_price_under": 1.709,
        "sportsbook": "Sporttrade (Arizona)",
        "bet_price_over": 2
    },
    {
        "_id": "67c0776913d53725f6b22609",
        "bet_price_under": 1.8,
        "sportsbook": "PointsBet (Ontario)"
    },
    {
        "_id": "67c0776913d53725f6b22c95",
        "bet_price_under": 1.69,
        "sportsbook": "BetMGM"
    },
    {
        "_id": "67c07aee13d53725f6b3965e",
        "bet_price_over": 2.1,
        "sportsbook": "TAB"
    },
    {
        "_id": "67c07aee13d53725f6b3981e",
        "bet_price_over": 2.09,
        "sportsbook": "Underdog Fantasy (Multipliers)"
    },
    {
        "_id": "67c07af013d53725f6b3a21c",
        "bet_price_over": 2.1,
        "sportsbook": "Picklebet"
    },
    {
        "_id": "67c07c0313d53725f6b5ff31",
        "bet_price_over": 2,
        "sportsbook": "Sporttrade",
        "bet_price_under": 1.709
    },
    {
        "_id": "67c07c0a13d53725f6b66a96",
        "bet_price_over": 2.1,
        "sportsbook": "Resorts World Bet",
        "bet_price_under": 1.69
    },
    {
        "_id": "67c07c1013d53725f6b6c41b",
        "bet_price_over": 1.917,
        "sportsbook": "Rebet",
        "bet_price_under": 1.699
    },
    {
        "_id": "67c07d8c13d53725f6cb5cf9",
        "bet_price_over": 1.909,
        "sportsbook": "Betfair"
    },
    {
        "_id": "67c07da313d53725f6cc9e9b",
        "bet_price_over": 2,
        "sportsbook": "Sportsbet"
    },
    {
        "_id": "67c07dd913d53725f6cfabe7",
        "bet_price_over": 2,
        "sportsbook": "Sporttrade (Iowa)",
        "bet_price_under": 1.709
    },
    {
        "_id": "67c07eea13d53725f6de9c88",
        "bet_price_under": 1.775,
        "sportsbook": "YouWager",
        "bet_price_over": 2
    },
    {
        "_id": "67c07eeb13d53725f6dea376",
        "bet_price_under": 1.775,
        "sportsbook": "Rebet Props City",
        "bet_price_over": 2
    }
]

export const linksPJ = [
	{
		outcome_id_normalized: '10459-30354-2025-02-27:Player Steals:Draymond Green:1.5:bet365',
		bet_price_over_history: [
			{
				price: 2.25,
				time: '2025-02-27T01:54:57.576Z',
			},
			{
				price: 2.25,
				time: '2025-02-27T02:29:54.358Z',
			},
			{
				price: 2.25,
				time: '2025-02-27T02:29:54.359Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T02:48:42.460Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T02:53:41.591Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:04:50.003Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:21:32.475Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:21:32.475Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:39:22.172Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:39:22.172Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:54:15.587Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T03:54:15.587Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T04:11:21.782Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T04:28:25.032Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T04:28:25.032Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T04:45:04.126Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T04:45:04.126Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:02:51.747Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:02:51.747Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:19:57.442Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T05:27:43.262Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:28:13.145Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:28:13.145Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:37:09.027Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:37:09.027Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:53:33.238Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T05:53:33.238Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T06:11:03.040Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T06:11:03.040Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T06:29:15.011Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T06:29:15.011Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T06:46:47.107Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T06:46:47.107Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:04:34.979Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:04:34.979Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:22:29.537Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:22:29.537Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:38:18.600Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:38:18.600Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:57:32.696Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T07:57:32.696Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T08:15:01.385Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T08:15:01.385Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T08:31:48.196Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T08:31:48.196Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T08:50:16.585Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T08:50:16.585Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T09:07:55.556Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T09:07:55.556Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T09:25:56.543Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T09:25:56.543Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T09:43:59.995Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T09:43:59.995Z',
			},
			{
				price: 2.32,
				time: '2025-02-27T10:02:41.847Z',
			},
			{
				price: 2.32,
				time: '2025-02-27T10:02:41.847Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T10:05:11.877Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T10:19:29.260Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T10:19:29.260Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T10:37:49.139Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T10:37:49.139Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T10:45:41.583Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T10:45:41.583Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T10:56:32.191Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T10:56:32.191Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T11:14:59.540Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T11:14:59.540Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T11:31:48.320Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T11:31:48.320Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T11:50:40.746Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T11:50:40.746Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T12:09:05.896Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T12:09:05.896Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T12:27:26.661Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T12:27:26.661Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T12:47:08.519Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T12:47:08.519Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T13:04:54.644Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T13:04:54.644Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T13:26:08.566Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T13:26:08.566Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T13:40:45.344Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T13:44:58.314Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T13:44:58.314Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T14:34:15.771Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T14:34:15.771Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T15:04:35.628Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T15:04:35.629Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:02:39.351Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:02:39.351Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:20:17.759Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:20:17.759Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T16:24:47.474Z',
			},
			{
				price: 2.3,
				time: '2025-02-27T16:24:47.474Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:26:44.834Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:59:44.044Z',
			},
			{
				price: 2.28,
				time: '2025-02-27T16:59:44.044Z',
			},
		],
		deep_link_over: {
			ios: 'com.bet365.bet365NJ://dl/sportsbookredirect',
			android: 'com.bet365.bet365NJ://dl/sportsbookredirect',
			desktop: 'https://www.<STATE>.bet365.com/#/AC/B18/C20604387/D19/E22054115/F19/I43/',
		},
		bet_price_under_history: [
			{
				price: 1.645,
				time: '2025-02-27T02:30:05.025Z',
			},
			{
				price: 1.645,
				time: '2025-02-27T02:30:05.025Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T02:48:42.460Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T02:53:41.591Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T03:21:04.600Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T03:21:04.600Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T03:39:21.834Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T03:39:21.834Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T03:55:21.749Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T03:55:21.749Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T04:11:35.512Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T04:11:35.512Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T04:44:39.521Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T04:44:39.521Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:03:06.522Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:03:06.522Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:19:45.307Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T05:27:43.262Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:28:13.145Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:28:13.145Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:36:36.662Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:36:36.661Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:54:59.958Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T05:54:59.958Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T06:11:06.255Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T06:11:06.255Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T06:28:20.487Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T06:28:20.487Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T06:46:44.473Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T06:46:44.473Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:04:05.918Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:04:05.918Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:22:16.789Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:39:45.391Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:39:45.391Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:56:17.483Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T07:56:17.483Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T08:14:52.659Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T08:14:52.660Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T08:33:04.126Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T08:33:04.127Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T09:07:28.538Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T09:07:28.538Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T09:25:41.553Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T09:25:41.553Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T09:43:27.239Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T09:43:27.239Z',
			},
			{
				price: 1.588,
				time: '2025-02-27T10:02:41.847Z',
			},
			{
				price: 1.588,
				time: '2025-02-27T10:02:41.847Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T10:05:11.877Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T10:39:06.414Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T10:39:06.414Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T10:45:41.583Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T10:45:41.583Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T10:56:43.614Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T10:56:43.614Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T11:15:11.412Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T11:15:11.412Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T11:33:30.108Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T11:33:30.107Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T11:50:20.322Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T11:50:20.322Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T12:09:10.106Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T12:09:10.106Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T12:47:38.631Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T12:47:38.631Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T13:06:23.517Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T13:06:23.517Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T13:26:20.041Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T13:26:20.041Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T13:40:45.344Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T13:44:39.519Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T14:34:15.771Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T14:34:15.771Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T15:04:08.996Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:03:47.013Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:03:47.013Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T16:24:47.474Z',
			},
			{
				price: 1.606,
				time: '2025-02-27T16:24:47.474Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:26:44.834Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:39:34.951Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:39:34.951Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:59:25.697Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T16:59:25.697Z',
			},
			{
				price: 1.625,
				time: '2025-02-27T17:58:39.213Z',
			},
		],
		deep_link_under: {
			ios: 'com.bet365.bet365NJ://dl/sportsbookredirect',
			android: 'com.bet365.bet365NJ://dl/sportsbookredirect',
			desktop: 'https://www.<STATE>.bet365.com/#/AC/B18/C20604387/D19/E22054115/F19/I43/',
		},
		sportsbook: "bet365"
	},
	// {
	// 	sportsbook: "bet365",
	// 	outcome_id_normalized: '35142-14251-2025-02-27:Player Steals:PJ Washington:1.5:bet365',
	// 	bet_price_under_history: [
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T04:26:13.327Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T04:28:12.241Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:03:02.616Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:03:02.616Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:19:21.976Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:19:21.976Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:36:20.451Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:36:20.451Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:55:11.178Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T05:55:11.178Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T06:11:45.447Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T06:11:45.447Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T06:28:51.353Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T06:28:51.353Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T06:47:35.882Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T07:22:09.114Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T07:40:01.692Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T07:40:01.692Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T08:14:51.274Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T08:14:51.274Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T08:50:48.635Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T08:50:48.635Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T10:03:20.179Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T10:03:20.179Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T10:36:41.694Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T10:36:41.694Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T11:32:28.099Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T11:32:28.100Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T11:52:33.442Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T12:09:25.484Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T12:09:25.484Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T12:27:57.769Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T12:27:57.769Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T12:46:34.737Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T12:46:34.737Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T13:25:31.030Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T13:25:31.030Z',
	// 		},
	// 		{
	// 			price: 1.444,
	// 			time: '2025-02-27T14:29:44.653Z',
	// 		},
	// 		{
	// 			price: 1.444,
	// 			time: '2025-02-27T14:43:44.340Z',
	// 		},
	// 		{
	// 			price: 1.444,
	// 			time: '2025-02-27T14:43:44.340Z',
	// 		},
	// 		{
	// 			price: 1.444,
	// 			time: '2025-02-27T15:42:06.031Z',
	// 		},
	// 		{
	// 			price: 1.444,
	// 			time: '2025-02-27T15:42:06.031Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:15:16.323Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:19:29.656Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T17:31:06.335Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:31:38.055Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:39:13.171Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:39:13.171Z',
	// 		},
	// 		{
	// 			price: 1.5,
	// 			time: '2025-02-27T17:41:06.520Z',
	// 		},
	// 		{
	// 			price: 1.5,
	// 			time: '2025-02-27T17:41:06.520Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:45:06.494Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:45:06.495Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T17:47:05.436Z',
	// 		},
	// 		{
	// 			price: 1.476,
	// 			time: '2025-02-27T17:48:05.999Z',
	// 		},
	// 		{
	// 			price: 1.455,
	// 			time: '2025-02-27T17:56:09.656Z',
	// 		},
	// 		{
	// 			price: 1.435,
	// 			time: '2025-02-27T18:00:06.642Z',
	// 		},
	// 	],
	// 	deep_link_under: {
	// 		android: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 		desktop: 'https://www.<STATE>.bet365.com/#/AC/B18/C20604387/D19/E22054117/F19/I43/',
	// 		ios: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 	},
	// 	bet_price_over_history: [
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T04:26:13.327Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:01:54.168Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:01:54.168Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:19:08.676Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:19:08.676Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:37:46.276Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:37:46.276Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:53:38.925Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T05:53:38.925Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T06:11:19.400Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T06:11:19.400Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T06:47:03.929Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T06:47:03.929Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T07:38:50.762Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T07:38:50.762Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T07:57:07.230Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T07:57:07.230Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T10:21:21.655Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T10:21:21.655Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T10:36:41.694Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T10:36:41.694Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T11:14:49.802Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T11:14:49.802Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T11:52:28.166Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T11:52:28.167Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T12:09:53.286Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T12:09:53.286Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T12:47:43.376Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T12:47:43.376Z',
	// 		},
	// 		{
	// 			price: 2.65,
	// 			time: '2025-02-27T14:29:44.653Z',
	// 		},
	// 		{
	// 			price: 2.65,
	// 			time: '2025-02-27T14:43:43.672Z',
	// 		},
	// 		{
	// 			price: 2.65,
	// 			time: '2025-02-27T15:42:02.149Z',
	// 		},
	// 		{
	// 			price: 2.65,
	// 			time: '2025-02-27T15:42:02.149Z',
	// 		},
	// 		{
	// 			price: 2.65,
	// 			time: '2025-02-27T16:59:25.892Z',
	// 		},
	// 		{
	// 			price: 2.65,
	// 			time: '2025-02-27T16:59:25.893Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:15:16.323Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:19:29.689Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:19:29.689Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T17:31:06.335Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:31:38.055Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:39:14.640Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:39:14.640Z',
	// 		},
	// 		{
	// 			price: 2.5,
	// 			time: '2025-02-27T17:41:06.520Z',
	// 		},
	// 		{
	// 			price: 2.5,
	// 			time: '2025-02-27T17:41:06.520Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:45:06.494Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:45:06.495Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T17:47:05.436Z',
	// 		},
	// 		{
	// 			price: 2.55,
	// 			time: '2025-02-27T17:48:05.999Z',
	// 		},
	// 		{
	// 			price: 2.6,
	// 			time: '2025-02-27T17:56:09.656Z',
	// 		},
	// 		{
	// 			price: 2.7,
	// 			time: '2025-02-27T18:00:06.642Z',
	// 		},
	// 	],
	// 	deep_link_over: {
	// 		android: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 		desktop: 'https://www.<STATE>.bet365.com/#/AC/B18/C20604387/D19/E22054117/F19/I43/',
	// 		ios: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 	},
	// },
	// {
	// 	sportsbook: "bet365",
	// 	outcome_id_normalized: '54023-12967-2025-02-27:1st Quarter Player Points:Damian Lillard:6.5:bet365',
	// 	bet_price_over_history: [
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T21:51:34.809Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T21:52:05.307Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T21:52:05.307Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:16:11.855Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:16:11.855Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-26T22:53:05.158Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-26T22:53:05.158Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:56:04.755Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-26T22:57:05.660Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:59:35.580Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:59:35.580Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:33:42.050Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:33:42.050Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:53:33.893Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:53:33.893Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:10:32.240Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:33:43.905Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:33:43.905Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T01:43:45.772Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:14:15.583Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:14:15.582Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:30:25.547Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:30:25.547Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:46:46.924Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:46:46.923Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:05:08.619Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:05:08.619Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:21:36.177Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:38:32.739Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:38:32.739Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:55:41.191Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:55:41.191Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:13:02.831Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:13:02.831Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:27:48.276Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:27:48.276Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T05:37:15.936Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T06:11:51.478Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T06:11:51.478Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T06:46:45.593Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T06:46:45.593Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:22:15.823Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:22:15.823Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:56:50.030Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:56:50.030Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T08:49:57.724Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T08:49:57.724Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:08:12.889Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:08:12.889Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:25:20.432Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:25:20.432Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:45:07.977Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:45:07.977Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:20:55.863Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:20:55.863Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:37:50.565Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:37:50.565Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T10:47:41.901Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T11:32:32.105Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T11:32:32.105Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T12:29:17.665Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T12:29:17.665Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T13:05:41.431Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T13:05:41.431Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T13:25:03.453Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T13:25:03.453Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T13:45:12.726Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T14:07:34.153Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T14:07:34.153Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T14:23:30.797Z',
	// 		},
	// 		{
	// 			price: 1.909,
	// 			time: '2025-02-27T14:23:30.797Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T14:48:15.123Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T15:02:30.358Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T15:02:30.358Z',
	// 		},
	// 	],
	// 	deep_link_over: {
	// 		ios: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 		android: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 		desktop: 'https://www.<STATE>.bet365.com/#/AC/B18/C20604387/D19/E22054116/F19/I43/',
	// 	},
	// 	bet_price_under_history: [
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T21:52:05.307Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T21:52:05.307Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:15:16.924Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:15:16.924Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-26T22:53:35.378Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-26T22:53:35.378Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:55:35.839Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-26T22:57:05.660Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:59:35.580Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T22:59:35.580Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:33:52.458Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:33:52.458Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-26T23:53:04.243Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:33:48.148Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:33:48.148Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:58:16.748Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T00:58:16.748Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T01:43:52.839Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:13:28.214Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:13:28.214Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:30:07.380Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:46:56.643Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T02:46:56.643Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:39:22.461Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:39:22.461Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:55:55.870Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T03:55:55.870Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:10:56.646Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:10:56.646Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:27:55.152Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:27:55.152Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:44:40.861Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T04:44:40.861Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T05:37:45.365Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T05:37:45.365Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T06:12:04.830Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T06:12:04.830Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:04:32.143Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:21:48.454Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:21:48.454Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:57:39.261Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T07:57:39.261Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:08:34.184Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:08:34.184Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:26:50.575Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T09:26:50.575Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:02:03.742Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:02:03.742Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:20:49.934Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:20:49.934Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:37:58.369Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T10:37:58.369Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T10:47:41.901Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T10:55:57.963Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T10:55:57.963Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T11:13:53.336Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T11:13:53.336Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T11:32:51.219Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T11:32:51.218Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T11:51:56.379Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T11:51:56.379Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T12:29:36.541Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T12:29:36.541Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T13:25:07.808Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T13:25:07.808Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T14:06:02.120Z',
	// 		},
	// 		{
	// 			price: 1.833,
	// 			time: '2025-02-27T14:06:02.119Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T14:48:15.123Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T15:02:33.208Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T15:02:33.208Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T17:58:41.239Z',
	// 		},
	// 		{
	// 			price: 1.87,
	// 			time: '2025-02-27T17:58:41.239Z',
	// 		},
	// 	],
	// 	deep_link_under: {
	// 		ios: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 		android: 'com.bet365.bet365NJ://dl/sportsbookredirect',
	// 		desktop: 'https://www.<STATE>.bet365.com/#/AC/B18/C20604387/D19/E22054116/F19/I43/',
	// 	},
	// },
];

export const parsedevScanResults = [
	{
        game: {
			away_team_display: 'Golden State Warriors',
            home_team_display: 'Orlando Magic',
            start_date: '2025-02-28T01:30:00Z'
		},
        link: {
            deep_link_under: {
                desktop: 'https://www.bet365.com/#/AC/B18/C20604387/D19/E22054117/F19/I0/'
            }
        },
        sharpLink: {
            deep_link_under: {
                desktop: 'https://www.pinnacle.com/en/basketball/nba/charlotte-hornets-vs-dallas-mavericks/1604903869/#player-props'
            }
        },
		level_0: 812,
		index: 4179,
		outcome_id_normalized: '10459-30354-2025-02-27:Player Steals:Draymond Green:1.5:bet365',
		bet_price_over_positive_dumb: null,
		game_id: '10459-30354-2025-02-27',
		is_locked_over: true,
		is_main: true,
		league: 'NBA',
		live: false,
		market: 'Player Steals',
		market_type: 'Player Prop',
		outcome_id_normalized_no_book: '10459-30354-2025-02-27:Player Steals:Draymond Green:1.5',
		sport: 'basketball',
		sportsbook_dumb: 'bet365',
		bet_price_under_negative_dumb: null,
		is_locked_under: false,
		start_date: 1740700800000,
		bet_price_over_dumb: 128,
		bet_price_under_dumb: -160,
		bet_price_over_negative_dumb: null,
		bet_price_under_positive_dumb: null,
		limit_dumb: null,
		bet_price_over_sharp: 162,
		sportsbook_sharp: 'Betway (Alaska)',
		limit_sharp: null,
		bet_price_over_negative_sharp: null,
		bet_price_over_positive_sharp: null,
		bet_price_under_sharp: -219.7802197802,
		sportsbook: 'Betway (Alaska)',
		limit: null,
		bet_price_under_negative_sharp: null,
		bet_price_under_positive_sharp: null,
		devigged1: 0.3465611413,
		devigged2: 0.6534388587,
		ev_over: -0.2098405979,
		ev_under: 0.0618381454,
		quarter_kelly_over: -4.0984491769,
		quarter_kelly_under: 2.4735258161,
		possible_sharps: 'Betway (Alaska),Pinnacle',
		ev: 0.0618381454,
		quarter_kelly: 2.4735258161,
		bet_price: '-160',
		selected_sharp_price: -219.7802197802,
		bet_name: 'Draymond Green under 1.5',
		sharp_prices: '-220 / +162',
		sharp_book: 'WagerWiz Mains'
	},
	{
        game: {
			away_team_display: 'Denver Nuggets',
            home_team_display: 'Milwaukee Bucks',
            start_date: '2025-02-28T01:30:00Z'
		},
        link: {
            deep_link_under: {
                desktop: 'https://www.bet365.com/#/AC/B18/C20604387/D19/E22054117/F19/I0/'
            }
        },
        sharpLink: {
            deep_link_under: {
                desktop: 'https://www.pinnacle.com/en/basketball/nba/charlotte-hornets-vs-dallas-mavericks/1604903869/#player-props'
            }
        },
		level_0: 824,
		index: 6383,
		outcome_id_normalized: '54023-12967-2025-02-27:1st Quarter Player Points:Damian Lillard:6.5:bet365',
		bet_price_over_positive_dumb: null,
		game_id: '54023-12967-2025-02-27',
		is_locked_over: true,
		is_main: false,
		league: 'NBA',
		live: false,
		market: '1st Quarter Player Points',
		market_type: 'Player Prop',
		outcome_id_normalized_no_book: '54023-12967-2025-02-27:1st Quarter Player Points:Damian Lillard:6.5',
		sport: 'basketball',
		sportsbook_dumb: 'bet365',
		bet_price_under_negative_dumb: null,
		is_locked_under: false,
		start_date: 1740704400000,
		bet_price_over_dumb: -114.9425287356,
		bet_price_under_dumb: -114.9425287356,
		bet_price_over_negative_dumb: null,
		bet_price_under_positive_dumb: null,
		limit_dumb: null,
		bet_price_over_sharp: 114,
		sportsbook_sharp: 'Betway (Alaska)',
		limit_sharp: null,
		bet_price_over_negative_sharp: null,
		bet_price_over_positive_sharp: null,
		bet_price_under_sharp: -151.9756838906,
		sportsbook: 'Betway (Alaska)',
		limit: null,
		bet_price_under_negative_sharp: null,
		bet_price_under_positive_sharp: null,
		devigged1: 0.4318056181,
		devigged2: 0.5681943819,
		ev_over: -0.1925234942,
		ev_under: 0.0625234942,
		quarter_kelly_over: -5.5322843157,
		quarter_kelly_under: 1.7966521318,
		possible_sharps: 'Betway (Alaska),Pinnacle',
		ev: 0.0625234942,
		quarter_kelly: 1.7966521318,
		bet_price: '-115',
		selected_sharp_price: -151.9756838906,
		bet_name: 'Damian Lillard under 6.5',
		sharp_prices: '-152 / +114',
		sharp_book: 'WagerWiz Mains'
	},
	{
		game: {
			away_team_display: 'Charlotte Hornets',
            home_team_display: 'Dallas Mavericks',
            start_date: '2025-02-28T01:30:00Z'
		},
        link: {
            deep_link_over: {
                desktop: 'https://www.bet365.com/#/AC/B18/C20604387/D19/E22054117/F19/I0/'
            }
        },
        sharpLink: {
            deep_link_over: {
                desktop: 'https://www.pinnacle.com/en/basketball/nba/charlotte-hornets-vs-dallas-mavericks/1604903869/#player-props'
            }
        },
		level_0: 923,
		index: 15315,
		outcome_id_normalized: '35142-14251-2025-02-27:Player Steals:PJ Washington:1.5:bet365',
		bet_price_over_positive_dumb: null,
		game_id: '35142-14251-2025-02-27',
		is_locked_over: false,
		is_main: true,
		league: 'NBA',
		live: false,
		market: 'Player Steals',
		market_type: 'Player Prop',
		outcome_id_normalized_no_book: '35142-14251-2025-02-27:Player Steals:PJ Washington:1.5',
		sport: 'basketball',
		sportsbook_dumb: 'bet365',
		bet_price_under_negative_dumb: null,
		is_locked_under: false,
		start_date: 1740706200000,
		bet_price_over_dumb: 170,
		bet_price_under_dumb: -229.8850574713,
		bet_price_over_negative_dumb: null,
		bet_price_under_positive_dumb: null,
		limit_dumb: null,
		bet_price_over_sharp: 126,
		sportsbook_sharp: 'Betway (Alaska)',
		limit_sharp: null,
		bet_price_over_negative_sharp: null,
		bet_price_over_positive_sharp: null,
		bet_price_under_sharp: -168.0672268908,
		sportsbook: 'Betway (Alaska)',
		limit: null,
		bet_price_under_negative_sharp: null,
		bet_price_under_positive_sharp: null,
		devigged1: 0.4073953815,
		devigged2: 0.5926046185,
		ev_over: 0.0999675301,
		ev_under: -0.1496123725,
		quarter_kelly_over: 1.4701107363,
		quarter_kelly_under: -8.5984122105,
		possible_sharps: 'Betway (Alaska),Pinnacle',
		sharp_book: 'WagerWiz Mains',
		ev: 0.0999675301,
		quarter_kelly: 1.4701107363,
		bet_price: '+170',
		selected_sharp_price: 126,
		bet_name: 'PJ Washington over 1.5',
		sharp_prices: '+126 / -168',
	},
];
